module.exports = __webpack_public_path__ + "img/iOS.38c00a51.svg";